module.exports = __webpack_public_path__ + "img/logo.57747d12.png";